import config from "~/config";

export async function getTickerMainApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/profile-main`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.TICKERS.fetch(request);
  }
}

export async function getTickerAiCompetitorApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/summary-competitors`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.TICKERS.fetch(request);
  }
}

export async function getTickerAiBullBearApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/summary-bull-bear`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.TICKERS.fetch(request);
  }
}

export async function getTickerAiSummaryApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/summary`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.TICKERS.fetch(request);
  }
}

export async function getProfileNumbersApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/numbers`;
  if (env?.IS_BROWSER) {
    return fetch(url, {});
  } else if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.TICKERS.fetch(request);
  }
}

export async function getStockPriceApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getPriceApiUrl()}api/tickers/${ticker.toLowerCase()}/price`;
  if (env?.IS_BROWSER) {
    return fetch(url, {});
  } else if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.PRICES.fetch(request);
  }
}

export async function getStockPriceSmall(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getPriceApiUrl()}api/tickers/${ticker.toLowerCase()}/price-small`;
  if (env?.IS_BROWSER) {
    return fetch(url, {});
  } else if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.PRICES.fetch(request);
  }
}

export async function getIncomeStatementsApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/income-statements`;
  if (env?.IS_BROWSER) {
    return fetch(url, {});
  } else if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.EDGAR.fetch(request);
  }
}

export async function getCashflowStatementsApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/cashflow-statements`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.EDGAR.fetch(request);
  }
}

export async function getBalanceSheetsApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/balance-sheets`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.EDGAR.fetch(request);
  }
}

export async function getNewsApi(ticker: string, { env }): Promise<any[]> {
  const url = `https://news.7baggers.com/api/tickers/${ticker.toLowerCase()}/news`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.NEWS.fetch(request);
  }
}

export async function getWorkerInsiderDataApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/insider_transactions`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.EDGAR.fetch(request);
  }
}

export async function getEdgar10Q10KS1FilingsApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/filings`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.EDGAR.fetch(request);
  }
}

export async function getTickerInsiderByPersonApi(
  ticker: string,
  person: string,
  { env },
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/persons/${person}/insider_transactions`;
  if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.EDGAR.fetch(request);
  }
}

export async function getProfileRestApi(
  ticker: string,
  { env },
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/profile-rest`;
  if (env?.IS_BROWSER) {
    return fetch(url, {});
  } else if (env?.IS_LOCAL) {
    return fetch(url, {});
  } else {
    const request = new Request(url, {
      method: "GET",
    });
    return env.TICKERS.fetch(request);
  }
}

export async function getTickersMapApi(): Promise<any[]> {
  const url = `https://screener.7baggers.com/api/tickersmap`;
  return fetch(url, {});
}

export async function crawlEdgerApi(
  token: string,
  ticker: string,
  crawlToTheEnd: boolean,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/edgar_crawl`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      crawlToTheEnd,
    }),
  });
  return await resp.json();
}

export async function crawlEdgerInsiderApi(
  token: string,
  ticker: string,
  crawlToTheEnd: boolean,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/edgar_crawl_insider`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      crawlToTheEnd,
    }),
  });
  return await resp.json();
}

export async function cacheInvalidateApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/cache-invalidate`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  return await resp.json();
}

export async function crawlPriceApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getPriceApiUrl()}api/tickers/${ticker.toLowerCase()}/price`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  return await resp.json();
}

export async function editStatementKey(
  token: string,
  ticker: string,
  type: string,
  key: string,
  value: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/statement-key`;
  const resp = await fetch(url, {
    method: "PUT",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      key,
      value,
      type,
    }),
  });
  return await resp.json();
}

export async function editStatementKeyReplacementApi(
  token: string,
  ticker: string,
  type: string,
  key: string,
  value: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/statement-key-replacement`;
  const resp = await fetch(url, {
    method: "PUT",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      key,
      value,
      type,
    }),
  });
  return await resp.json();
}

export async function parseDocumentApi(
  token: string,
  ticker: string,
  cik: string,
  accessionNumber: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/recalculate-one-filing`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ticker,
      accession_number: accessionNumber,
    }),
  });
  return await resp.json();
}

export async function crawlSummaryApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker}/crawl-summary`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ticker,
    }),
  });
  return await resp.json();
}

export async function crawlBullBearApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker}/crawl-bull-bear`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ticker,
    }),
  });
  return await resp.json();
}

export async function crawlCompetitorsApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getTickerApiUrl()}api/tickers/${ticker}/crawl-competitors`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ticker,
    }),
  });
  return await resp.json();
}

export async function crawlTranscriptByDateApi(
  token: string,
  ticker: string,
  datestr: string | undefined,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/crawl-transcript-by-date/${datestr}`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  });
  return await resp.json();
}

export async function parseBeforeDateDocumentApi(
  token: string,
  ticker: string,
  datestr: string | undefined,
): Promise<any[]> {
  if (!datestr) {
    return;
  }
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/process-statements-before/${datestr}`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  return await resp.json();
}

export async function hideStatementDateApi(
  token: string,
  ticker: string,
  datestr: string | undefined,
): Promise<any[]> {
  if (!datestr) {
    return;
  }
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/hide-statements-by-date/${datestr}`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  return await resp.json();
}

export async function hideParseResultApi(
  token: string,
  ticker: string,
  cik: string,
  accessionNumber: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/hide-one-filing`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ticker,
      accession_number: accessionNumber,
    }),
  });
  return await resp.json();
}

export async function setAnnualApi(
  token: string,
  ticker: string,
  cik: string,
  accessionNumber: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/set-annual`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ticker,
      accession_number: accessionNumber,
    }),
  });
  return await resp.json();
}

export async function loginApi(
  username: string,
  password: string,
): Promise<any[]> {
  const resp = await fetch(`${config.getAuthApiUrl()}api/auth/login`, {
    method: "POST",
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  });
  return await resp.json();
}

export async function loginGoogleApi(credential: string): Promise<any> {
  const resp = await fetch(`${config.getAuthApiUrl()}api/auth/login-google`, {
    method: "POST",
    credentials: "include",
    mode: "cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ credential }),
  });
  return await resp.json();
}

export async function registerGoogleApi(
  username: string,
  credential: string,
): Promise<any> {
  const resp = await fetch(
    `${config.getAuthApiUrl()}api/auth/register-google`,
    {
      method: "POST",
      credentials: "include",
      mode: "cors",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, credential }),
    },
  );
  return await resp.json();
}

export async function registerApi(info: any): Promise<any> {
  const resp = await fetch(`${config.getAuthApiUrl()}api/auth/register`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(info),
  });
  return await resp.json();
}

export async function requestResetPasswordApi(email: string): Promise<any> {
  const resp = await fetch(`${config.getAuthApiUrl()}api/auth/request-reset`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email }),
  });
  return await resp.json();
}

export async function resetPasswordApi(
  resetcode: string,
  password: string,
): Promise<any> {
  const resp = await fetch(`${config.getAuthApiUrl()}api/auth/reset-password`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ resetcode, password }),
  });
  return await resp.json();
}

export async function sendEmailcode(emailcode: string): Promise<any> {
  const resp = await fetch(
    `${config.getAuthApiUrl()}api/auth/verify-email/${emailcode}`,
    {
      method: "GET",
    },
  );
  return await resp.json();
}

export async function getLoggedinApi(token: string, { env }): Promise<any[]> {
  const url = `${config.getAuthApiUrl()}api/auth/loggedin`;
  if (env?.IS_LOCAL) {
    return fetch(url, {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
  } else {
    const request = new Request(url, {
      method: "GET",
      headers: {
        Authorization: token,
        "Cache-Control": "public, max-age=5",
        "Content-Type": "application/json",
      },
    });
    return env.AUTH.fetch(request);
  }
}

export async function logoutApi(): Promise<any[]> {
  const url = `${config.getAuthApiUrl()}api/auth/logout`;
  return fetch(url, {
    method: "GET",
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
  });
}

export async function processStatementsApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/process-statements`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  return await resp.json();
}

export async function deleteParsedResultsApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  const url = `${config.getEdgarApiUrl()}api/tickers/${ticker.toLowerCase()}/parsed-results`;
  const resp = await fetch(url, {
    method: "DELETE",
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({}),
  });
  return await resp.json();
}

export async function editTickerApi(
  token: string,
  ticker: string,
  key: string,
  value: string,
): Promise<any[]> {
  try {
    const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ key, value }),
    });
    return await resp.json();
  } catch (err) {
    throw new Error(err.message);
  }
}

export async function saveMetaDataApi(
  token: string,
  ticker: string,
  data: any,
): Promise<any[]> {
  try {
    const url = `${config.getTickerApiUrl()}api/tickers/${ticker.toLowerCase()}/misc-data`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data }),
    });
    return await resp.json();
  } catch (err) {
    throw new Error(err.message);
  }
}

export async function deleteTickerWorkerApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  try {
    const resp = await fetch(
      `https://screener.7baggers.com/api/tickers/${ticker.toLowerCase()}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ticker }),
      },
    );
    return await resp.json();
  } catch (err) {
    throw new Error(err.message);
  }
}

export async function addTickerWorkerApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  try {
    const resp = await fetch(`https://screener.7baggers.com/api/tickers`, {
      method: "POST",
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ticker }),
    });
    return await resp.json();
  } catch (err) {
    throw new Error(err.message);
  }
}

export async function addTickerProfileApi(
  token: string,
  ticker: string,
): Promise<any[]> {
  try {
    const url = `${config.getTickerApiUrl()}api/tickers`;
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ticker }),
    });
    return await resp.json();
  } catch (err) {
    throw new Error(err.message);
  }
}
